import React from 'react'
import './car-service-footer.css'
import { Link } from 'react-router-dom'

export default function carservicefooter() {
  return (
   <footer className="footer">
  <div className="footerContainer">

    {/* LEFT – Brand */}
    <div className="footerBrand">
      <img
        src="/carServiceImages/carlogo.png"
        alt="AutoMechanica Logo"
      />
      <p>
        AutoCare’s mission is to enable premium quality care for your luxury
        car service at affordable pricing. We ensure real-time updates for complete
        car care needs with a fair and transparent pricing mechanism.
      </p>
    </div>

    {/* SERVICES */}
    <div className="footerCol">
      <h4>Services</h4>
      <ul>
        <li><Link to="/services/periodic-maintenance">Periodic Maintenance Service</Link></li>
        <li><Link to="/services/denting-painting">Dent & Paint</Link></li>
        <li><Link to="/services/bumper-repair">Bumper Repair</Link></li>
        <li><Link to="/services/accidental-repair">Accidental Repair</Link></li>
        <li><Link to="/services/scratch-removal">Scratch Removal</Link></li>
      </ul>
    </div>

    {/* LINKS */}
<div className="footerCol">
  <h4>Links</h4>
  <ul>
    <li><Link to="/">Home</Link></li>
    <li><Link to="/about">About</Link></li>
    <li><Link to="/faq">FAQ</Link></li>
    <li><Link to="https://www.instagram.com/autocare2026?igsh=a2x1ZXEzcW9nNms0">Instagram</Link></li>
    <li><Link to="/autocare">AutoCare</Link></li>
    <li><Link to="/contact">Contact Us</Link></li>
    <li>Privacy Policy</li>
  </ul>
</div>


    {/* CONTACT */}
    <div className="footerCol">
      <h4>Contact</h4>

   <h5>AutoCare Car Service Center</h5> 
<p>Shop No. 12, Ground Floor,
Near City Hospital,
Huda Sector 2,
Palwal, Haryana – 121102</p>
      <p>Email: contact@autocare.com</p>
      <p>Phone: XXXXXXX7</p>
    </div>

  </div>

  {/* BOTTOM BAR */}
  <div className="footerBottom">
    <p>Copyright © 2025 AutoCare. All rights reserved.</p>
  </div>
</footer>

  )
}
